export const ADMIN_PATHS = {
  dashboard: '/admin/dashboard',
  evaluations: {
    list: '/admin/evaluations',
    new: '/admin/evaluations/new',
    edit: (evaluationId: string) => `/admin/evaluations/${evaluationId}/edit`,
    variantNew: (evaluationId: string) => `/admin/evaluations/${evaluationId}/variants/new`,
    variantEdit: (evaluationId: string, variantId: string) =>
      `/admin/evaluations/${evaluationId}/variants/${variantId}/edit`,
  },
  users: {
    list: '/admin/users',
    new: '/admin/users/new',
    edit: (userId: string) => `/admin/users/${userId}/edit`,
  },
  tests: {
    list: '/admin/tests',
    new: '/admin/tests/new',
    edit: (testKey: string) => `/admin/tests/${testKey}/edit`,
  },
  userTests: {
    list: '/admin/user-tests',
    new: '/admin/user-tests/new',
    detail: (userTestKey: string) => `/admin/user-tests/${userTestKey}`,
  },
  promoCodes: {
    list: '/admin/promo-codes',
    new: '/admin/promo-codes/new',
    edit: (promoCodeId: string) => `/admin/promo-codes/${promoCodeId}/edit`,
  },
  skills: {
    list: '/admin/skills',
    new: '/admin/skills/new',
    edit: (skillId: string) => `/admin/skills/${skillId}/edit`,
  },
  skillGroups: {
    list: '/admin/skill-groups',
    new: '/admin/skill-groups/new',
    edit: (skillGroupId: string) => `/admin/skill-groups/${skillGroupId}/edit`,
  },
  skillGrids: {
    list: '/admin/skill-grids',
    new: '/admin/skill-grids/new',
    edit: (skillGridId: string) => `/admin/skill-grids/${skillGridId}/edit`,
  },
  positions: {
    list: '/admin/positions',
    new: '/admin/positions/new',
    edit: (positionId: string) => `/admin/positions/${positionId}/edit`,
  },
  library: {
    steps: '/admin/steps',
    stepNew: '/admin/steps/new',
    stepEdit: (stepId: string) => `/admin/steps/${stepId}/edit`,
    rules: '/admin/rules',
    checkboxes: '/admin/checkboxes',
    checkboxNew: '/admin/checkboxes/new',
    checkboxEdit: (checkboxId: string) => `/admin/checkboxes/${checkboxId}/edit`,
  },
  skillUpNodes: {
    list: '/admin/skill-up-nodes',
    new: '/admin/skill-up-nodes/new',
    edit: (nodeId: string) => `/admin/skill-up-nodes/${nodeId}/edit`,
    links: (nodeId: string) => `/admin/skill-up-nodes/${nodeId}/links`,
  },
  skillUpConcepts: {
    list: '/admin/skill-up-concepts',
    new: '/admin/skill-up-concepts/new',
    edit: (conceptId: string) => `/admin/skill-up-concepts/${conceptId}/edit`,
    roadmap: (conceptId: string) => `/admin/skill-up-concepts/${conceptId}/roadmap`,
  },
  llmConfig: {
    fragments: '/admin/llm-config/fragments',
    fragmentNew: '/admin/llm-config/fragments/new',
    fragment: (key: string) => `/admin/llm-config/fragments/${key}`,
    presets: '/admin/llm-config/presets',
    presetNew: '/admin/llm-config/presets/new',
    preset: (id: string) => `/admin/llm-config/presets/${id}`,
  },
} as const;
